import Splide from '@splidejs/splide';
import { Build, Component, Element, h, Host, Prop } from '@stencil/core';

@Component({
    tag: 'web-carousel',
    styleUrl: 'carousel.scss',
    shadow: false
})
export class Carousel {
    @Element() private rootElement: HTMLWebCarouselElement;

    @Prop() controlType: 'none' | 'simple' | 'full' = 'simple';
    @Prop() tileSize: 'small' | 'large' = 'small';
    @Prop() arrowNextLabel = 'Next';
    @Prop() arrowPreviousLabel = 'Previous';
    @Prop() perPage = 2;
    @Prop() loop = true;

    private carouselElement!: HTMLElement;
    private content!: Element[];

    componentWillLoad() {
        const slot = this.rootElement.querySelector('#slot-default');
        this.content = slot ? Array.from(slot.children) : Array.from(this.rootElement.children);
    }

    componentDidLoad() {
        if (!Build.isBrowser) {
            return;
        }

        const style = getComputedStyle(this.rootElement);
        const fixedWidth = style.getPropertyValue('--web-carousel-slide-width') ?? '16.5rem';
        const gap = style.getPropertyValue('--web-carousel-slide-gap') ?? '1.6rem';
        const move = this.perPage;
        const type = this.loop === true ? 'loop' : 'slide';

        new Splide(this.carouselElement, {
            type,
            pagination: true,
            perPage: move,
            gap,
            fixedWidth,
            perMove: move,
            role: 'group',
            i18n: {
                prev: this.arrowPreviousLabel,
                next: this.arrowNextLabel,
                first: this.arrowNextLabel,
                last: this.arrowPreviousLabel
            }
        }).mount();
    }

    render() {
        return (
            <Host>
                <div
                    ref={(el) => (this.carouselElement = el as HTMLElement)}
                    class={`splide controls-${this.controlType} tile-size-${this.tileSize}`}
                    style={{ visibility: 'visible' }}
                >
                    <div class="splide__track">
                        <div class="splide__list">
                            {this.content.map((item) => (
                                <div role="group" class="splide__slide" innerHTML={item.outerHTML}></div>
                            ))}
                        </div>
                    </div>

                    <div class="splide__arrows">
                        <button
                            class="splide__arrow splide__arrow--prev"
                            aria-label={this.arrowPreviousLabel}
                            title={this.arrowPreviousLabel}
                        >
                            <web-icon name="chevron-left"></web-icon>
                            <span class="label-previous">{this.arrowPreviousLabel}</span>
                        </button>
                        <ul class="splide__pagination"></ul>
                        <button
                            class="splide__arrow splide__arrow--next"
                            aria-label={this.arrowNextLabel}
                            title={this.arrowNextLabel}
                        >
                            <span class="label-next">{this.arrowNextLabel}</span>
                            <web-icon name="chevron-right"></web-icon>
                        </button>
                    </div>
                </div>
                <div id="slot-default" style={{ display: 'none' }}>
                    <slot />
                </div>
            </Host>
        );
    }
}
